import { TTagDB, TTagUI } from './tags.types';
import { EEventPartType } from './events.types';
import { EAttendanceStatus } from './registrants.types';

export type TEventSessionDateUI = {
  partType: EEventPartType;
  date: string | null;
};

export type TEventParentAttendanceUI = {
  partType: EEventPartType;
  attendanceStatus: EAttendanceStatus;
};

export type TEventParentAttendancesDB = Partial<
  Record<EEventPartType, EAttendanceStatus>
>;

export enum EEventParentsFilterParams {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  MOBILE = 'phone',
  LOCATION = 'locationIds',
  TYPE = 'eventTypes',
  TITLE = 'title',
  HOST = 'hostIds',
  TAGS = 'tagIds',
  ATTENDANCE = 'attendance',
}

export enum EEventParentsSortParams {
  REGISTRATION_DATE = 'registrationDate',
}

export type TEventParentHostType = 'ORGANIZATION' | 'ELC';

export type TEventSessionDateDB = Record<EEventPartType, string | null>;

export type TEventParentDataUI = {
  registrantId: string;
  eventId: string;
  eventClassId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  childrenNames: string[];
  location: string;
  ageGroup: string;
  eventType: string;
  registrationDate: string | null;
  eventTitle: string;
  host: TEventParentHostType | null;
  hostId: string | null;
  hostType: TEventParentHostType | null;
  sessionDates: TEventSessionDateUI[];
  tags?: TTagUI[];
  attendances: TEventParentAttendanceUI[];
};

export type TEventParentDataDB = {
  registrantId: string;
  eventId: string;
  eventPartId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  childrenNames: string[];
  location: string;
  ageGroup: string;
  eventType: string;
  registrationDate: string | null;
  eventTitle: string;
  host: TEventParentHostType | null;
  hostId: string | null;
  hostType: TEventParentHostType | null;
  sessionDates: TEventSessionDateDB;
  tags?: TTagDB[];
  attendances?: TEventParentAttendancesDB | null;
};

export type TEditEventParentUI = {
  eventId: string;
  registrantId: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
};

export type TEditEventParentDB = {
  eventId: string;
  registrantId: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
};

export type TEventParentsExportSort = {
  field: 'FIRST_NAME' | 'LAST_NAME' | 'CREATION_DATE' | 'REGISTRATION_DATE';
  direction: 'ASC' | 'DESC';
};

export type TEventParentsExportFilters = {
  ids?: string[];
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  title?: string;
  locations?: string[];
  eventTypes?: string[];
  hostIds?: string[];
  tags?: string[];
  isActiveOnly?: boolean;
  hasAttended?: boolean;
};

export type TEventParentsExportRequest = {
  columns?: string[];
  filters?: TEventParentsExportFilters;
  sort?: TEventParentsExportSort;
};
